import styled from 'styled-components';
import PropTypes from 'prop-types';
import { BATTLESHIP, FLINT } from 'HubStyleTokens/colors';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIInputGroup from 'UIComponents/form/UIInputGroup';
import UIStepperInput from 'UIComponents/input/UIStepperInput';
import UIFormControl from 'UIComponents/form/UIFormControl';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const castAsNumber = value => value || value === 0 ? +value : undefined;
const LinkIconContainer = styled.div.withConfig({
  displayName: "Dimensions__LinkIconContainer",
  componentId: "sc-1wpsle0-0"
})(["display:flex;flex-grow:0;flex-basis:auto;padding:44px 0 0;"]);
const Dimensions = props => /*#__PURE__*/_jsxs(UIInputGroup, {
  gap: true,
  children: [/*#__PURE__*/_jsx(UIFormControl, {
    className: "m-all-0",
    label: props.widthLabel,
    children: /*#__PURE__*/_jsx(UIStepperInput, {
      "data-selenium": props.widthSeleniumKey,
      max: props.maxWidth,
      min: 0,
      onChange: props.onWidthChange,
      readOnly: props.readOnly,
      stepSize: 1,
      use: props.useOnDark ? 'on-dark' : 'default',
      value: castAsNumber(props.width)
    })
  }), /*#__PURE__*/_jsx(LinkIconContainer, {
    children: /*#__PURE__*/_jsx(UIIcon, {
      className: "m-x-2 p-bottom-2",
      color: props.useOnDark ? FLINT : BATTLESHIP,
      name: "link",
      size: "xxs",
      style: {
        alignSelf: 'center'
      }
    })
  }), /*#__PURE__*/_jsx(UIFormControl, {
    className: "m-all-0",
    label: props.heightLabel,
    children: /*#__PURE__*/_jsx(UIStepperInput, {
      "data-selenium": props.heightSeleniumKey,
      max: props.maxHeight,
      min: 0,
      onChange: props.onHeightChange,
      readOnly: props.readOnly,
      stepSize: 1,
      use: props.useOnDark ? 'on-dark' : 'default',
      value: castAsNumber(props.height)
    })
  })]
});
Dimensions.propTypes = {
  height: PropTypes.node,
  heightLabel: PropTypes.node.isRequired,
  heightSeleniumKey: PropTypes.string,
  maxHeight: PropTypes.number,
  maxWidth: PropTypes.number,
  onHeightChange: PropTypes.func.isRequired,
  onWidthChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  useOnDark: PropTypes.bool,
  width: PropTypes.node,
  widthLabel: PropTypes.node.isRequired,
  widthSeleniumKey: PropTypes.string
};
export default Dimensions;